import PropTypes from 'prop-types';
import React from 'react';
import CSSModules from 'react-css-modules';
import styles from './CheckBoxInput.scss';
import tooltip from 'components/common/material/Tooltip';
import IconButton from 'components/common/material/IconButton';
const IconButtonTooltip = tooltip(IconButton);

class CheckBoxInput extends React.Component {

  constructor () {
    super(...arguments);
  }


  static propTypes = {
    dataAt: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.bool,
    text: PropTypes.string,
    checkBoxStatus: PropTypes.bool,
    onChange: PropTypes.func,
    toolTipText: PropTypes.string,
  };

  static defaultProps = {
    dataAt: "",
    name: "",
    value: false,
    text : "",
    toolTipText : "",
    onChange: ()=>{},
    checkBoxStatus: true,
  };

  onCheckBoxClick = (checkBoxStatus) => {
    if(this.props.onChange) {
      this.props.onChange(checkBoxStatus);
    }
  };

  render() {
    const {dataAt , name , value , checkBoxStatus , text , toolTipText} = this.props;
    return (
      <div className={styles.checkbox}>
        <input  type="checkbox"
                name={name}
                id="checkbox"
                value={value}
                checked={checkBoxStatus}
                onChange={(e) => this.onCheckBoxClick(e.target.checked)}
                data-at={dataAt}/>
        <label htmlFor="checkbox" />
        <span className={styles.radioTextCardAutoPay}>{text}</span>
        {toolTipText !== "" &&
        <IconButtonTooltip tooltipShowOnClick={true}
                           icon="info_outline"
                           theme={{ tooltip : "tooltip-checkBox-input"}}
                           className={"checkBox-input-tooltip"}
                           tooltip={toolTipText} />}

      </div>
    );
  }
}

// export default CheckBoxInput;
export default CSSModules(styles, {allowMultiple: true})(CheckBoxInput);



// WEBPACK FOOTER //
// ./src/components/common/Input/CheckBoxInput.js